import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditIcon from '@mui/icons-material/Edit';
import TableCellTooltip from '../../../common/TableCellTooltip';
import { createCommaSeparatedString, focusElemnt, navigation3 } from '../../../common/helper';
import * as mdt from '../../../common/modaltypes';
import { BranchMasterExcelColDefs, columnDefs as originalColumnDefs } from './BrnchMasterConstant';
import moment from 'moment/moment';

const BranchMAsterExcelTable = (props) => {
    const { tableData,  loginData } = props
  // Memoize column definitions
  const columnDefs = useMemo(() => BranchMasterExcelColDefs, []);

  return (
      <TableContainer className='scrollBlue' component={Paper} sx={{ display:'none',maxHeight: '70vh', marginBottom: "5px" }}>
          <Table id='cityPairExelTbl' stickyHeader size="small" aria-label="a dense table">
              <TableHead sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                  <TableRow>
                      <TableCell
                          className="reportTD"
                          style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                          colSpan={7}

                      >
                          <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Branch Master Details</h3>
                      </TableCell>
                      <TableCell
                          className="reportTD"
                          style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'right' }}
                          colSpan={7}

                      >
                          <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
                      </TableCell>
                  </TableRow>
                  <TableRow >
                  <TableCell  colSpan={14}></TableCell>
                  </TableRow>
                  <TableRow>
                      {columnDefs.map((col, index) => (
                          <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', padding: '8px 6px !important', minHeight: '36px !important', fontSize: '14px', fontWeight: '700', color: '#444' }}>
                              {col.headerName}
                          </TableCell>
                      ))}
                  </TableRow>
              </TableHead>
              {/* <TableBody sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                  {reportData.map((val, index) => (
                      <TableRow key={`DR-${index}`} sx={{ backgroundColor: selModalRow === index && showModal && mdt.editBranchMaster === modalType ? '#FFFDAF99' : '' }}>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
                          <TableCellTooltip title={loginData?.strCompanyName} data={loginData?.strCompanyName} placement={'bottom-start'} textAlign={"left"} maxWidth={'160px'} />
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.BranchID}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.BranchCode}</TableCell>
                          <TableCellTooltip title={val.BranchName} data={val.BranchName} placement={'bottom-start'} textAlign={"left"} maxWidth={'15%'} />
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CityName}</TableCell>
                          <TableCellTooltip title={val.StateName} data={val.StateName} placement={'bottom-start'} textAlign={"left"} maxWidth={'90px'} />
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.BranchType}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.GSTN}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CargoGSTNO}</TableCell>
                          <TableCellTooltip title={val.BranchManagerName} data={val.BranchManagerName} placement={'bottom-start'} textAlign={"left"} maxWidth={'100px'} />
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ContactNo1}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CreatedDatetime === "" ? '' : moment(val.CreatedDatetime).format('DD MMM YYYY,HH:mm')}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ModifiedDatetime === "" ? '' : moment(val.ModifiedDatetime).format('DD MMM YYYY,HH:mm')}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ModifiedByUser}</TableCell>
                          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                            {val.IsActive === 1?'Yes':"No"}
                          </TableCell>
                      </TableRow>
                  ))}
              </TableBody> */}
                 {tableData?.length > 0 ? <TableBody>
                        {tableData?.map((val, index) => (
                            <TableRow key={`CityPairDataCol-${index}`}>
                                {columnDefs.map((col, index1) => (
                                    <TableCell
                                        key={`CityPairDataCol-${index}-${index1}`}
                                        style={{
                                            ...col.headerSx,
                                            height: '40px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#444',
                                        }}
                                    >
                                        {val?.[col.field]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={columnDefs?.length}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>}
          </Table>
      </TableContainer>
  );
}

export default BranchMAsterExcelTable
